/* ============================================================
   Zina Tahiri — custom lightweight wishlist (no third-party app)
   Stores product handles in the browser's localStorage, so it
   works with no customer account. Related files:
   assets/wishlist.css, snippets/wishlist-button.liquid,
   templates/page.wishlist.json, sections/main-product.liquid
   ============================================================ */
(function () {
  'use strict';

  var STORAGE_KEY = 'zt-wishlist-v1';

  function getWishlist() {
    try {
      var list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(list)) return [];
      return list.filter(function (h) {
        return typeof h === 'string' && h.length > 0;
      });
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable — the wishlist simply won't persist */
    }
  }

  function isWishlisted(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggleWishlist(handle) {
    var list = getWishlist();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle);
    else list.splice(i, 1);
    saveWishlist(list);
  }

  /* Sync every heart button on the page with the stored state */
  function refreshHearts() {
    document.querySelectorAll('[data-zt-wishlist]').forEach(function (btn) {
      var on = isWishlisted(btn.getAttribute('data-zt-wishlist'));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    /* Header heart fills whenever the wishlist has at least one item */
    var hasItems = getWishlist().length > 0;
    document.querySelectorAll('.header__icon--wishlist .zt-heart-header').forEach(function (icon) {
      icon.classList.toggle('is-active', hasItems);
    });
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[c];
    });
  }

  /* Minimal formatter covering Shopify's common money formats */
  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    function delimited(n, precision, thousands, decimal) {
      var fixed = (n / 100).toFixed(precision == null ? 2 : precision);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    var value;
    if (format.indexOf('amount_no_decimals_with_comma_separator') !== -1) {
      value = delimited(cents, 0, ',', '.');
    } else if (format.indexOf('amount_with_comma_separator') !== -1) {
      value = delimited(cents, 2, ',', '.');
    } else if (format.indexOf('amount_no_decimals_with_space_separator') !== -1) {
      value = delimited(cents, 0, ' ', '.');
    } else if (format.indexOf('amount_with_apostrophe_separator') !== -1) {
      value = delimited(cents, 2, "'", '.');
    } else if (format.indexOf('amount_no_decimals') !== -1) {
      value = delimited(cents, 0, ',', '.');
    } else {
      value = delimited(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  /* Render the /pages/wishlist grid from stored handles */
  function renderWishlistPage() {
    var container = document.querySelector('[data-zt-wishlist-page]');
    if (!container) return;

    var list = getWishlist();
    var moneyFormat = container.getAttribute('data-zt-money-format') || '${{amount}}';

    if (!list.length) {
      container.innerHTML =
        '<div class="zt-wishlist-empty">' +
        '<p>Your wishlist is empty.</p>' +
        '<a href="/collections/all" class="link">Continue shopping</a>' +
        '</div>';
      return;
    }

    container.innerHTML = '<p class="zt-wishlist-loading">Loading your wishlist&hellip;</p>';

    Promise.all(
      list.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (results) {
      var valid = [];
      results.forEach(function (p) {
        if (p) valid.push(p);
      });
      /* Drop handles that no longer resolve (deleted/unpublished products) */
      if (valid.length !== list.length) {
        saveWishlist(
          valid.map(function (p) {
            return p.handle;
          })
        );
      }
      if (!valid.length) {
        renderWishlistPage();
        return;
      }
      var cards = valid
        .map(function (p) {
          var img = p.featured_image
            ? '<div class="zt-wishlist-card__media"><img src="' +
              escapeHtml(p.featured_image) +
              '" alt="' +
              escapeHtml(p.title) +
              '" loading="lazy"></div>'
            : '';
          return (
            '<div class="zt-wishlist-card">' +
            '<a class="zt-wishlist-card__link" href="' +
            escapeHtml(p.url) +
            '">' +
            img +
            '<h3 class="zt-wishlist-card__title">' +
            escapeHtml(p.title) +
            '</h3>' +
            '<p class="zt-wishlist-card__price">' +
            escapeHtml(formatMoney(p.price, moneyFormat)) +
            '</p>' +
            '</a>' +
            '<button type="button" class="zt-wishlist-remove" data-zt-remove="' +
            escapeHtml(p.handle) +
            '">Remove</button>' +
            '</div>'
          );
        })
        .join('');
      container.innerHTML = '<div class="zt-wishlist-grid">' + cards + '</div>';
    });
  }

  document.addEventListener('click', function (event) {
    var heart = event.target.closest('[data-zt-wishlist]');
    if (heart) {
      event.preventDefault();
      toggleWishlist(heart.getAttribute('data-zt-wishlist'));
      refreshHearts();
      return;
    }
    var remove = event.target.closest('[data-zt-remove]');
    if (remove) {
      var handle = remove.getAttribute('data-zt-remove');
      saveWishlist(
        getWishlist().filter(function (h) {
          return h !== handle;
        })
      );
      refreshHearts();
      renderWishlistPage();
    }
  });

  function init() {
    refreshHearts();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
